<template>
    <div class="Publicheader">
        <v-app-bar
        app
        color="#0FDC88"
        dark
        >
        <v-btn text rounded ><h2>{{$t('(HIES/BA)')}}</h2></v-btn>
        <v-spacer></v-spacer>
        <Switchlang></Switchlang>
        <!-- <v-btn text rounded @click="goToLogin">{{$t('logmasukB')}}</v-btn> -->
        <!-- <v-btn text rounded @click="goToDaftar">{{$t('daftarB')}}</v-btn> -->
        <v-btn text rounded @click="tetapkansemula">{{$t('lupakatalaluan')}}</v-btn>
        <v-btn text rounded @click="downloadUserManual">{{$t('manual pengguna')}}</v-btn>
        </v-app-bar>
    </div>
</template>
<script>
import Switchlang  from "@/components/Switchlang/switchlang"
import axios from 'axios'
import i18n from '@/i18n'
export default {
    name: 'Publicheader',
    components: {
        Switchlang
    },
    data: () => ({
    }),
    methods: {
        // goToFrontline(){
        //     this.$router.push('/')
        // },
        tetapkansemula(){
            this.$router.push(`/${i18n.locale}/lupatakalaluan`).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    throw err;
                }
            });
        },
        goToLogin() {
            this.$router.push(`/`).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    throw err;
                }
            });
        },
        goToDaftar(){
            // alert(i18n.locale)
            this.$router.push(`/${i18n.locale}/daftar`).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    throw err;
                }
            });
        },
        downloadUserManual(){
                window.location.href = '/usermanual.pdf';
                //window.location.href = 'https://hiesba.dosm.gov.my/usermanual.pdf';
                // await axios.get('10.21.45.164', { responseType: 'blob' })
                // //Axios.get(url, { responseType: 'blob' })
                // .then(response => {
                //     const blob = new Blob([response.data], { type: 'application/pdf' })
                //     const link = document.createElement('a')
                //     link.href = URL.createObjectURL(blob)
                //     link.download = label
                //     link.click()
                //     URL.revokeObjectURL(link.href)
                // }).catch(console.error)
        }
    },
    setup() {
        
    },
}
</script>
<style>
</style>